<template>
  <div id="app" class="w-100">
    <Header class="sticky-top"></Header>
    <router-view></router-view>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
export default {
  name: 'App',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    Header
  }
}
</script>

<style lang="scss">
//@import "~@/assets/scss/vendors/bootstrap-vue/index";
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
